import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_OFFER_EXPIRATION_MUTATION = gql`
  mutation updateOfferExpirationMutation(
    $documentVersion: DocumentVersionInput!,
    $expirationDate: Date!) {
    custom {
      editExpirationDate(documentId: $documentVersion, expirationDate: $expirationDate) {
        documentId
        revision
        status
        snkModifier {
          profile {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOfferExpirationMutation extends Mutation<RootMutation> {
  document = UPDATE_OFFER_EXPIRATION_MUTATION;
}
